import { render, staticRenderFns } from "./q4.vue?vue&type=template&id=05405edc&scoped=true&"
import script from "./q4.vue?vue&type=script&lang=js&"
export * from "./q4.vue?vue&type=script&lang=js&"
import style0 from "./q4.vue?vue&type=style&index=0&id=05405edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05405edc",
  null
  
)

export default component.exports